var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "-7.768 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Trash / delete",
    fill: "#376996"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 254",
    d: "M41.141 4.56H28.792V3.329A3.313 3.313 0 0 0 25.504 0h-6.543a3.313 3.313 0 0 0-3.289 3.329v1.232H3.319A3.313 3.313 0 0 0-.004 7.856v2.177a3.3 3.3 0 0 0 2.038 3.038c.379 7.547 2.571 44.037 2.67 45.676A1.333 1.333 0 0 0 6.039 60h32.387a1.333 1.333 0 0 0 1.331-1.253c.1-1.639 2.291-38.129 2.67-45.676a3.3 3.3 0 0 0 2.038-3.038V7.855a3.313 3.313 0 0 0-3.324-3.295ZM18.339 3.329a.644.644 0 0 1 .622-.662h6.542a.644.644 0 0 1 .622.662v1.232h-7.786V3.329ZM2.666 7.855a.643.643 0 0 1 .656-.628h37.819a.643.643 0 0 1 .656.628v2.177a.644.644 0 0 1-.656.628H3.319a.643.643 0 0 1-.656-.628V7.855Zm34.5 49.478H7.294c-.391-6.523-2.186-36.509-2.573-44.006h35.022c-.387 7.497-2.182 37.483-2.573 44.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 255",
    d: "M22.233 27.567A1.033 1.033 0 0 0 21.2 28.6v25.977a1.033 1.033 0 0 0 2.065 0V28.6a1.033 1.033 0 0 0-1.032-1.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 256",
    d: "M12.884 28.587a1.032 1.032 0 0 0-2.062.108l1.354 25.936a1.032 1.032 0 0 0 1.03.979h.055a1.032 1.032 0 0 0 .977-1.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 257",
    d: "M32.665 27.61a1.027 1.027 0 0 0-1.085.977l-1.355 25.936a1.032 1.032 0 0 0 .977 1.085h.055a1.032 1.032 0 0 0 1.03-.979l1.355-25.936a1.032 1.032 0 0 0-.977-1.083Z"
  }))));
};
export default SvgTrash;